import Waypoint from "../Utils/Waypoint";
import Main from "@/ts/base/Main";

interface ServerResponse {
	success: boolean;
	html: string;
	loaded: number[];
	total: number;
}

export default class PostLoader {
	static get LoadStart() {
		return "PostLoader.Start";
	}

	static get LoadSuccess() {
		return "PostLoader.Success";
	}

	static get LoadError() {
		return "PostLoader.Error";
	}

	container: HTMLElement;
	id: string;
	postType: string;
	triggerButton: HTMLElement | null;
	isAutoLoadOnInView: boolean;
	isLoading: boolean;
	waypoint: Waypoint | null;


	constructor(containerElement: HTMLElement, postType: string) {
		this.container = containerElement;
		this.id = this.container.id;
		this.postType = postType;
		this.triggerButton = window.document.getElementById(`${this.id}__LoadMoreButton`);
		this.isAutoLoadOnInView = this.getIsAutoLoad();
		this.isLoading = false;
		this.waypoint = null;
		this.init();
	}


	init(): void {
		this.container.dataset.loader = JSON.stringify(this);
		this.triggerButton?.addEventListener("click", this.onTriggerClick.bind(this));

		if (this.isAutoLoadOnInView) {
			if (this.triggerButton) {
				this.triggerButton.dataset.triggerAlways = "";
				this.triggerButton?.addEventListener(Waypoint.InViewClass, this.loadArticles.bind(this));
				this.waypoint = new Waypoint(this.triggerButton);
			}
		}
		else {
			this.loadArticles();
		}
	}

	getIsAutoLoad(): boolean {
		return this.container.dataset.autoload === "1";
	}

	getLoadMax(): number {
		return parseInt(<string>this.container.dataset.loadMax);
	}

	setLoadMax(value: number) {
		this.container.setAttribute("data-load-max", value.toString());
	}

	setQueryVar(key: string, value: any) {
		const args = JSON.parse(window.atob(<string>this.container.dataset.queryVars));
		if (value !== null) {
			args[key] = value;
		}
		else {
			delete args[key];
		}

		this.container.dataset.queryVars = window.btoa(JSON.stringify(args));
	}

	/**
	 *
	 */
	loadArticles() {
		let loadMax = Number.parseInt(String(this.container.dataset.loadMax));
		let total = Number.parseInt(String(this.container.dataset.total));
		let loadedPostIDs = String(this.container.dataset.loadedIds);
		let loopTpl = String(this.container.dataset.loopTpl);
		let nonce = String(this.container.dataset.nonce);
		let vars = String(this.container.dataset.queryVars);
		const numLoaded = loadedPostIDs.split(",").length;

		if (nonce === undefined || (numLoaded >= total && total !== 0)) {
			this.triggerButton?.remove();
			return;
		}

		this.container.dispatchEvent(new Event(PostLoader.LoadStart));
		this.isLoading = true;

		const data = new FormData();
		data.append("action", "Posts/Load");
		data.append("_wpnonce", nonce);
		data.append("loadMax", loadMax.toString());
		data.append("loadedPostIDs", loadedPostIDs);
		data.append("loopTpl", loopTpl);
		data.append("queryVars", vars);

		if (this.triggerButton !== null) {
			this.triggerButton.classList.add("loading");
		}

		window.fetch(Main.Instance.options.url.ajax, {
			body: data,
			method: "POST",
			credentials: "same-origin",
			headers: {
				"Accept": "application/json"
			}
		}).then(async (resp) => {
			if (this.triggerButton !== null) {
				this.triggerButton.classList.remove("loading");
				this.triggerButton.classList.remove(Waypoint.InViewClass);
				this.triggerButton.classList.remove(Waypoint.LeftViewClass);
			}

			const result = await resp.json();

			this.onLoadSuccess(result.data);
		}).catch(reason => {
			this.onLoadError(reason);
		})
			.finally(() => {
				this.isLoading = false;
				this.maybeRemoveTriggerButton();
			});
	}

	maybeRemoveTriggerButton() {
		const foundRows = Number.parseInt(String(this.container.dataset.total));
		const loadedIds = String(this.container.dataset.loadedIds);

		let numLoaded = 0;

		if (loadedIds.length > 0) {
			if (loadedIds.indexOf(",") > -1) {
				numLoaded = loadedIds.split(",").length;
			}
			else if (loadedIds.match(/\d+/)) {
				numLoaded = 1;
			}
		}

		if (foundRows === numLoaded && this.triggerButton !== null) {
			this.triggerButton.style.display = "none";
			if (!this.isAutoLoadOnInView) {
				this.triggerButton = null;
			}
		}
		else if (this.triggerButton !== null) {
			this.triggerButton.style.display = "";
		}
	}

	reset() {
		this.container.dataset.loadedIds = "";
		this.container.dataset.total = "0";
		this.container.innerHTML = "";
		if (this.triggerButton instanceof HTMLElement) {
			this.triggerButton.style.display = "";
		}
	}

	onLoadSuccess(data: ServerResponse) {

		this.container.innerHTML += data.html;
		this.container.dataset.loadedIds = data.loaded.join(",");
		this.container.dataset.total = data.total.toString();
		this.container.dispatchEvent(new Event(PostLoader.LoadSuccess))
	}

	onLoadError(error: string) {
		if (this.triggerButton !== null) {
			this.container.dispatchEvent(new Event(PostLoader.LoadError));
		}
	}

	onTriggerClick(e: Event) {
		if (!this.isLoading && (this.triggerButton instanceof HTMLButtonElement && !this.triggerButton.disabled)) {
			this.loadArticles();
		}
	}

}
